import { useEffect, useState } from "react";

import LoadingSpinner from "@/components/common/common/LoadingSpinner";
import NoData from "@/components/common/common/Nodata";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Pagination from "@/components/user/common/Pagination";
import TitleBox from "@/components/user/common/TitleBox";
import { IBoardListParams } from "@/constants/common/listParams";
import usePagination from "@/hooks/common/usePagination";
import { useUrlParams } from "@/hooks/common/useUrlParams";
import { useGetBoardList } from "@/service/user/board";

interface Item {
    idx: number;
    num: number | string;
    b_title: string;
    b_contents: string;
}

export default function Faq() {
    // URL 파라미터 관리
    const { params, updateParams } = useUrlParams<IBoardListParams>({
        page: { defaultValue: 1, type: "number" },
    });
    const [totalPages, setTotalPages] = useState(1);
    const { currentPage, pages, setCurrentPage } = usePagination({ totalPages, initialPage: params.page });
    const [items, setItems] = useState<Item[]>([]);
    const { data: listData, isLoading: isInitialLoading } = useGetBoardList(
        "167",
        "10",
        params.page.toString(),
        "title",
        "",
        { enabled: true },
    );

    // currentPage 변경 시 URL 파라미터 업데이트
    const handleChangeCurrentPage = (page: number) => {
        updateParams({
            page: page,
        });
        setCurrentPage(page);
    };

    // 게시글 목록 조회
    useEffect(() => {
        if (listData) {
            const data = listData.data;
            setItems(data.board_list);
            setTotalPages(data.last_page);
        } else {
            setItems([]);
            setTotalPages(1);
        }
    }, [listData]);

    return (
        <div className="mx-auto w-full max-w-[1400px] px-[20px] xl:px-0">
            <TitleBox title="FAQ" text="자주 묻는 질문" />
            <div className="p-[28px_0_100px] md:p-[48px_0_160px]">
                <div className="rounded-[20px] bg-white p-[20px] md:p-[40px] xl:rounded-[40px] xl:p-[60px]">
                    {isInitialLoading ? (
                        <div className="py-[40px]">
                            <LoadingSpinner />
                        </div>
                    ) : items.length > 0 ? (
                        <>
                            <Accordion type="multiple" className="border-t border-black">
                                {items.map((item, i) => (
                                    <AccordionItem key={`faq_${i}`} value={`faq_${i}`}>
                                        <AccordionTrigger className="hover:no-underline md:p-[30px_20px] [&_svg]:size-[24px]">
                                            <div className="flex flex-col items-start gap-[5px] md:flex-row md:items-center md:gap-[32px]">
                                                <p className="text-[28px] font-[500] text-primary md:w-[100px] md:text-[36px]">
                                                    Q
                                                </p>
                                                <p className="text-left text-[18px] font-[500]">{item.b_title}</p>
                                            </div>
                                        </AccordionTrigger>
                                        <AccordionContent className="whitespace-pre-line border-t border-[#ddd] bg-[#FAFAFD] p-[15px_10px] text-[16px] leading-[1.5] text-[#666] md:p-[25px_20px] md:text-[18px] xl:p-[25px_90px_25px_150px]">
                                            <div dangerouslySetInnerHTML={{ __html: item.b_contents }} />
                                        </AccordionContent>
                                    </AccordionItem>
                                ))}
                            </Accordion>
                            <div className="flex justify-center p-[40px_0_20px]">
                                <Pagination
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    pages={pages}
                                    handleChangePage={handleChangeCurrentPage}
                                />
                            </div>
                        </>
                    ) : (
                        <NoData />
                    )}
                </div>
            </div>
        </div>
    );
}
